var map = {
	"./Feather-1.png": 787,
	"./Feather-2.png": 288,
	"./TSChat.png": 133,
	"./agrocafe-banner.jpg": 807,
	"./agrocafe-thumbnail.png": 901,
	"./agrocafe2-banner.png": 760,
	"./agrocafe2-thumbnail.png": 554,
	"./animeasy-banner.png": 531,
	"./animeasy-thumbnail.png": 15,
	"./botanica-banner.png": 16,
	"./botanica-thumbnail.png": 458,
	"./criarideias-banner.png": 567,
	"./criarideias-thumbnail.png": 219,
	"./fastalk-banner.png": 819,
	"./fastalk-thumbnail.png": 706,
	"./fox.jpg": 810,
	"./geoespinhaco-banner.png": 541,
	"./geoespinhaco-thumbnail.svg": 928,
	"./higher-banner.png": 771,
	"./higher-thumbnail.png": 733,
	"./hubtel-banner.png": 519,
	"./hubtel-thumbnail.png": 889,
	"./metahumans-banner.png": 165,
	"./metahumans-thumbnail.webp": 100,
	"./mundonovo-banner.png": 492,
	"./mundonovo-thumbnail.png": 553,
	"./oncoffee-banner.png": 73,
	"./oncoffee-thumbnail.png": 701,
	"./redecabral-banner.png": 13,
	"./redecabral-thumbnail.png": 406,
	"./resume-portuguese.pdf": 641,
	"./resume.pdf": 162,
	"./spaceinvaders-banner.png": 749,
	"./spaceinvaders-thumbnail.png": 828,
	"./sweden-banner.png": 387,
	"./sweden-thumbnail.png": 585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;